export default "__VITE_ASSET__D$HYTHXF__"